import { render, staticRenderFns } from "./PostSection3.vue?vue&type=template&id=5b0f7a8a&scoped=true"
import script from "./PostSection3.vue?vue&type=script&lang=js"
export * from "./PostSection3.vue?vue&type=script&lang=js"
import style0 from "./PostSection3.vue?vue&type=style&index=0&id=5b0f7a8a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0f7a8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0f7a8a')) {
      api.createRecord('5b0f7a8a', component.options)
    } else {
      api.reload('5b0f7a8a', component.options)
    }
    module.hot.accept("./PostSection3.vue?vue&type=template&id=5b0f7a8a&scoped=true", function () {
      api.rerender('5b0f7a8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blog/PostSection3.vue"
export default component.exports